//本地存储封装
const KEY_USER = "user"
let SessionStore = {
    //设置用户
    setUser(user){
        this.setObject(KEY_USER, user);
    },
    //获取用户
    getUser() {
        return this.getObject(KEY_USER)
    },
    /**
     * 判断当前用户是否可配置设备参数（对齐 acc-app：仅系统管理员、单位管理员）
     * @returns {boolean} true 表示可进入参数设置
     */
    canSettingDeviceParams() {
        const user = this.getUser();
        if (!user) {
            return false;
        }
        // 超级管理员：字段标识或角色编码
        if (user.supperAdmin || user.superAdmin) {
            return true;
        }
        const roles = user.roles || [];
        // super_admin=系统管理员；admin=单位管理员
        return roles.some(r => r && (r.roleCode === "super_admin" || r.roleCode === "admin"));
    },
    //清除用户
    clearUser() {
        this.clear(KEY_USER)
    },
    setObject(k, v) {
        sessionStorage.setItem(k, JSON.stringify(v))
    },
    getObject(k) {
        let str = sessionStorage.getItem(k)
        if(!str) return null;
        return JSON.parse(str);
    },
    getObjectAndClear(k) {
      let obj = this.getObject(k);
      this.clear(k);
      return obj;
    },
    set(k, v){
        sessionStorage.setItem(k, v);
    },
    get(k) {
        return sessionStorage.getItem(k)
    },
    clear(k) {
        sessionStorage.removeItem(k);
    }
}

export default SessionStore;
